import React from 'react';
import { MapPin, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HeroStrip } from './Shinobi';

const PageHeader = ({
  title,
  subtitle,
  icon: Icon,
  showSearch = false,
  searchValue = '',
  onSearchChange,
  onSearch,
  searchPlaceholder = 'Search...',
  actions,
  lastRefresh,
  showBackButton = false,
  onBack,
  accent = 'purple',
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  const rightSlot = (
    <>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
      {lastRefresh && (
        <div className="text-xs text-gray-500 ml-2 whitespace-nowrap">
          Last refresh: {lastRefresh}
        </div>
      )}
    </>
  );

  return (
    <HeroStrip
      icon={Icon}
      title={title}
      subtitle={subtitle}
      accent={accent}
      actions={rightSlot}
      onBack={showBackButton ? handleBack : undefined}
    >
      {showSearch && (
          <div className="mt-3 flex items-center gap-2 max-w-xl">
            <MapPin className="w-4 h-4 text-shinobi-green flex-shrink-0" />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && onSearch && onSearch()}
              placeholder={searchPlaceholder}
              className="terminal-input flex-1 px-3 py-1.5 rounded-md text-sm"
            />
            <button
              onClick={onSearch}
              className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-md text-shinobi-green border border-wasabi-300 hover:bg-wasabi-100 transition-colors"
            >
              <RefreshCw className="w-3.5 h-3.5" />
              <span>Search</span>
            </button>
          </div>
        )}
    </HeroStrip>
  );
};

export default PageHeader;
